<template>
  <div class="create-survey-wrapper">
    <h1>Umfrage erstellen</h1>
    <SurveyForm v-model="model"></SurveyForm>
    <AdaButton :loading="loading" style="width: 600px" title="Umfrage erstellen" @click="createSurvey"
               icon="icon-add"
               type="fullWidthButton"></AdaButton>
  </div>
</template>

<script>

import AdaButton from "../components/AdaButton";
import {RepositoryFactory} from "../scripts/RepositoryFactory";
import SurveyForm from "../components/SurveyForm";

const SurveysRepository = RepositoryFactory.get('surveys');

const MIN_DELIVERY_DELAY = 0;
const MAX_DELIVERY_DELAY = 48;

export default {
  name: "CreateSurvey",
  components: {
    AdaButton,
    SurveyForm
  },
  data: function () {
    return {
      loading: false,
      model: {
        name: '',
        order_name: '',
        order_id: null,
        creatives: '',
        cg_creatives: '',
        delivery_delay: 1,
        test_size: 300,
        line_items: '',
        dmp_pixel: '',
        brand: '',
        date_start: '',
        date_end: '',
        segment_id: '',
        tv_segment: '',
        app_segment: '',
        termination_criteria: 1,
        interest_query: 1,
        questions: [
          {
            text: 'Kennen Sie die Marke [Brand]?',
            multiple_choice: false,
            social_question: false,
            answers: [
              {
                text: 'Ja'
              },
              {
                text: 'Nein'
              }
            ],
            minimize: true,
            disabled: false
          },
          {
            text: 'Haben Sie in letzter Zeit Werbung für die Marke [Brand] gesehen?',
            multiple_choice: false,
            social_question: false,
            answers: [
              {
                text: 'Ja'
              },
              {
                text: 'Nein'
              }
            ],
            minimize: true,
            disabled: false
          },
          {
            text: 'Ist Ihnen die Marke [Brand] sympathisch?',
            multiple_choice: false,
            social_question: false,
            answers: [
              {
                text: 'Ja'
              },
              {
                text: 'Nein'
              }
            ],
            minimize: true,
            disabled: false
          },
          {
            text: 'Würden Sie Produkte der Marke [Brand] kaufen?',
            multiple_choice: false,
            social_question: false,
            answers: [
              {
                text: 'Ja'
              },
              {
                text: 'Nein'
              }
            ],
            minimize: true,
            disabled: false
          }
        ]
      }
    }
  },
  computed: {},
  methods: {
    async createSurvey() {
      try {
        if (isNaN(this.model.delivery_delay) ||
            parseInt(this.model.delivery_delay) < MIN_DELIVERY_DELAY ||
            parseInt(this.model.delivery_delay) > MAX_DELIVERY_DELAY) {
          this.$noty.error(`Die Auslieferungsverzögerung muss eine Zahl sein und zwischen ${MIN_DELIVERY_DELAY} und
                        ${MAX_DELIVERY_DELAY} Stunden liegen`);
          return;
        }
        this.loading = true;
        let res = await SurveysRepository.createSurvey(this.model);
        this.loading = false;
        if (typeof res.data.error !== 'undefined' && res.data.error !== null) {
          this.$noty.warning('Die Umfrage wurde erstellt, die Umfrage ID konnte aber nicht bei den ' +
              'Creatives eingetragen werden. Mögliche Ursache: falsche Creative IDs. Fehler: ' + res.data.error, {
            timeout: 10000
          });
        } else {
          this.$noty.success('Die Umfrage wurde erfolgreich erstellt');
        }
        await this.$router.push('/surveys');
      } catch (e) {
        this.loading = false;
        this.$noty.error("Fehler bei der Erstellung: \n" + e.response.data.error);
      }
    }
  },
  mounted() {
    console.log('mounted');
  }
}
</script>
<style lang="scss" scoped>

.create-survey-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 600px;
}

.create-form {
  width: 600px;
}

.create-form > div {
  margin-bottom: 20px;
}

.split-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

</style>